import BasicModal from '@/components/UI/Dialog'
import { Box, Checkbox, FormControlLabel, Typography } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

interface IConfirmationModalProps {
  show: boolean
  onClickDelete: (del: boolean) => void
  onClickCancel: () => void
  onClickClose?: () => void
}

export default function DeleteConfirmModal(props: IConfirmationModalProps) {
  const { t } = useTranslation('translation')
  const [deleteIntents, setdeleteIntents] = useState(false)

  return (
    <BasicModal
      open={props.show}
      onClose={props.onClickClose}
      sx={{ width: 430, height: 'auto' }}
      title={t('Confirm Delete')}
      footerActions={[
        {
          title: t('Delete'),
          variant: 'outlined',
          color: 'error',
          onClick: () => props.onClickDelete(deleteIntents),
        },
        {
          title: t('Cancel'),
          variant: 'outlined',
          onClick: props.onClickCancel,
        },
      ]}
    >
      <Box mt={2}>
        <Typography variant="body3" mb={1}>
          {t('Are you sure you want to delete? Deleted Items will be ')}{' '}
          <Typography
            variant="body3"
            color="error"
            fontWeight={700}
            component="span"
          >
            {t('deleted permanently.')}
          </Typography>
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              checked={deleteIntents}
              onChange={e => setdeleteIntents(e.target.checked)}
            />
          }
          label={t(
            'Delete all the intents associated with this documents as well',
          )}
        />
      </Box>
    </BasicModal>
  )
}
